import { DatadogDurationVital } from '@/components/constants/datadog-vitals';
import { Button } from '@heidi/design-system/button';

import { useSessionsFilters } from '@/components/layout/Navigation/sessions/header/toolbar/filters/hooks/useSessionsFilters';
import { DatadogDurationVitalStopper } from '@/components/utils/datadogDurationVitalStopper';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { CalendarX, X } from 'lucide-react';

export const SessionsListEmpty = () => {
  const { t } = useTranslations();
  const { isFilterApplied, handleClearFilters } = useSessionsFilters();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="content-center rounded-lg bg-background-tertiary p-4">
        <CalendarX size={23} className="text-text-secondary" />
      </div>
      <div className="relative flex flex-col items-center gap-2">
        <TypographyP2 className="text-text-secondary">
          {t('sessions.noSessionsFound')}
        </TypographyP2>
        {isFilterApplied && (
          <Button
            disableAutomaticSvgSizing
            variant="ghost"
            size="sm"
            className="text-text-secondary"
            onClick={handleClearFilters}
          >
            <X size={14} />
            <TypographyCaption>{t('sessions.clearFilters')}</TypographyCaption>
          </Button>
        )}
      </div>
      <DatadogDurationVitalStopper
        vitalName={[
          DatadogDurationVital.SESSION_SEARCH_RENDERED_V3,
          DatadogDurationVital.SESSION_SEARCH_RENDERED_V2,
          DatadogDurationVital.SESSION_SEARCH_RENDERED_V1,
        ]}
        disableRafBehaviour
      />
    </div>
  );
};
